import React from "react";
import DatePickerInner from './DatePickerInner';

export default class WaitDialog extends React.Component {

    render (){

        return ( 

        <div style={{display: this.props.show == true ? 'block' : 'none'}}> 
            <div style={mainClass}>
        <div style={message} >Attendere...{this.props.index ? this.props.index : ''}</div>
            </div>
        </div>
        )
    }


}

const mainClass = {
    position: 'fixed',
    top: '25%',
    left: '25%', 
    width: '50%',
    height: '50%',
    border: '1px solid black',
    background: '#ffffff'
}

const message = {
    textAlign: 'center',
    top: '45%',
    position: 'relative',
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}